import { useState, useEffect } from 'react'
import Select from '~/components/Select'
import ErrorMessage from '~/components/ErrorMessage'
import moment from 'moment'
import Card from '../components/Card'
import http from '~/http'
import Banner from './Banner'
import './WEDIndustryStudentRosterPage.scss'
import { downloadFromBlob } from '~/utilities/fileDownload'
import Button from '~/components/Button'

export default function WEDIndustryStudentRosterPage () {
  const [globalError, setGlobalError] = useState(null)
  const [sectionOptions, setSectionOptions] = useState([])
  const [sectionNumber, setSectionNumber] = useState('')
  const [students, setStudents] = useState([])

  const searchSections = async () => {
    const sectionSearchInfo = {
      sectionDate: new Date(Date.now())
    }
    const response = await http(setGlobalError, http => http.post('/api/SelfService/Students/WedIndustrySectionSearch', sectionSearchInfo))
    const sectionSearchData = response.data
    const dropdownData = sectionSearchData.map(x => {
      return { value: x.courseSectionNumber, label: `${x.courseSectionNumber} - ${x.courseTitle}` }
    })

    setSectionOptions(dropdownData)
  }

  const updateSectionNumber = (value) => {
    setSectionNumber(value)
    getStudents(value)
  }

  const getStudents = async (sectionNumber) => {
    const response = await http(setGlobalError, http => http.get(`/api/SelfService/Students/WedIndustrySectionStudents/${sectionNumber}`))
    const studentsData = response.data
    setStudents(studentsData)
  }

  const downloadRoster = async () => {
    // Generate and download CSV
    const studentData = students.map(student => ({
      'Last Name': student.lastName,
      'First Name': student.firstName,
      'Sponsoring Company': student.sponsoringCompany,
      'Employing Company': student.employingCompany
    }))

    const csvRows = []
    const headers = Object.keys(studentData[0]) // headers are always the first row
    const sectionName = sectionOptions.filter(s => s.value === sectionNumber)[0].label
    // headers.unshift(`Section: ${sectionName}`) // Add Section Name header
    csvRows.push(headers.join(','))

    for (const row of studentData) {
      const values = headers.map(e => {
        return row[e]
      })
      csvRows.push(values.join(','))
    }

    const csv = csvRows.join('\n')
    const blob = new window.Blob([csv], { type: 'text/csv' })
    downloadFromBlob(blob, `Section: ${sectionName} - ${moment().tz('America/Chicago').format('MM-DD-YYYY-h:mm a')}.csv`)
  }

  useEffect(() => {
    searchSections()
  }, [])

  return (
    <div className='page students'>
      <Banner message={`Students registered: ${students.length}`} />
      <div className='center'>
        <Select
          label='Class Section Number *'
          required
          options={sectionOptions}
          onChange={evt => updateSectionNumber(evt.value)}
        />
      </div>
      <div className='page-body'>
        {globalError && <ErrorMessage message={globalError} />}
        {!sectionNumber ? (
          <div className='no-students row'>
            <div>Please select a course section to get started.</div>
          </div>
        )
          : students.length === 0 ? (
            <div className='no-students row'>
              <div>There are currently no students registered for this course section.</div>
            </div>
          ) : (
            <>
              <div className='row'>
                <Button
                  unelevated
                  label='Download'
                  className='download-button'
                  onClick={downloadRoster}
                  theme={['primaryBg']}
                />
              </div>
              {students.map((student, i) =>
                <StudentCard
                  key={`student-${student.publicId}-${student.firstName}-${student.lastName}`}
                  student={student}
                />
              )}
            </>
          )}
      </div>
    </div>
  )
}

function StudentCard (props) {
  const { student } = props

  const {
    firstName,
    middleName,
    lastName
  } = student

  return (
    <Card className='card student-card'>
      <div className='row'>
        <span className='cell title'>{lastName}, {firstName} {middleName}</span>
      </div>
    </Card>
  )
}
